"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fakerBr = exports.maskBr = exports.utilsBr = exports.validateBr = void 0;
var utils_1 = require("./src/utils");
var validate_1 = require("./src/validate");
Object.defineProperty(exports, "validateBr", { enumerable: true, get: function () { return validate_1.validateBr; } });
var faker_1 = require("./src/faker");
var mask = require("./src/mask");
var mask_1 = require("./src/mask");
var placa_1 = require("./src/placa");
var estados_1 = require("./src/estados");
exports.utilsBr = {
    isPresent: utils_1.isPresent,
    isArray: utils_1.isArray,
    isString: utils_1.isString,
    isNumber: utils_1.isNumber,
    isNil: utils_1.isNil,
    processCaretTraps: utils_1.processCaretTraps,
    allNumbersAreSame: utils_1.allNumbersAreSame,
    getAllDigits: utils_1.getAllDigits,
    getAllWords: utils_1.getAllWords,
    currencyToNumber: utils_1.currencyToNumber,
    numberToCurrency: utils_1.numberToCurrency,
    slugify: utils_1.slugify,
    fillString: utils_1.fillString,
    randArray: utils_1.randArray,
    rand: utils_1.rand,
    randomNumber: utils_1.randomNumber,
    randomLetter: utils_1.randomLetter,
    randomLetterOrNumber: utils_1.randomLetterOrNumber,
    getSpecialProperty: utils_1.getSpecialProperty,
    MASKS: mask_1.MASKS,
    MASKSIE: mask_1.MASKSIE,
    PLACAS_RANGE: placa_1.PLACAS_RANGE,
    ESTADOS: estados_1.ESTADOS
};
exports.maskBr = mask.maskBr;
exports.fakerBr = faker_1.default;
//# sourceMappingURL=index.js.map